export const FETCH_FAULT_RESULT_REQUEST = "FETCH_FAULT_RESULT_REQUEST";
export const FETCH_FAULT_RESULT_SUCCESS = "FETCH_FAULT_RESULT-SUCCESS";
export const FETCH_FAULT_RESULT_FAILURE = 'FETCH_FAULT_RESULT_FAILURE';
